module.exports = __webpack_public_path__ + "circle_bookshelf_sm.e6e3994d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/circle_bookshelf_sm.svg
 ** module id = 985
 ** module chunks = 0
 **/